/**
 * CaseBlink brand colours as plain hex strings.
 *
 * The single source of truth for the palette is the `--color-brand-*` scale in
 * `src/styles/theme.css` (utilities like `bg-brand-primary`, or
 * `var(--color-brand-primary)` in style objects). Import from here ONLY when a
 * real hex value is required: values persisted to the backend, colour math
 * (`hexToRgb`, contrast checks), canvas/PDF output, or SVG exported outside the
 * DOM. Keep both files in sync.
 *
 * Brand blue is the mark fill in `src/assets/brand/mark/caseblink-mark.svg`.
 */

/** brand-600 / `--color-brand-primary`. */
export const BRAND_BLUE = "#201CD1";
/** brand-700; hover on brand-blue surfaces. */
export const BRAND_BLUE_HOVER = "#1A17AB";
/** brand-800; pressed state on brand-blue surfaces. */
export const BRAND_BLUE_ACTIVE = "#151287";
/** brand-900; dark brand ink for headings and illustrations. */
export const BRAND_INK = "#0E0C5A";

/** `rgba()` of brand blue at the given alpha, for shadows and tints. */
export function brandBlueAlpha(alpha: number): string {
  return `rgba(32, 28, 209, ${alpha})`;
}
